export const HomesteadCashPurchase = {
  Name: 'Homestead Cash Purchase',
  BuyerForms: [
    'Waiver of Inspection    (no charge)',
    'Recording Fee    (included)',
    'Closing Fee    (included)',
    'Overnight/Wire fee    (if applicable)',
  ],
  BuyerPrice: '$250.00',
  SellerForms: [
    'Warranty Deed (Special or General)    (included)',
    'Affidavit of Debts and Liens    (no charge)',
    'IRS 1099    (no charge)',
    'T-47 (Survey Affidavit) - If using existing survey    (no charge)',
    'Tax Certificate    (included)',
    'Closing Fee    (included)',
    'Overnight/Wire Fee    (if applicable)',
  ],
  SellerPrice: '$425.00',
};
